import { useEffect, useState } from 'react';

/** Seconds until the server rolls for you; 0 if no deadline. Anchored against drift. */
export function useAutoRollCountdown(
  deadline: string | null | undefined,
  active: boolean
): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active || !deadline) return;
    // The clock may have moved a long way since the last tick.
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, [active, deadline]);

  if (!active || !deadline) return 0;
  const left = new Date(deadline).getTime() - now;
  return Math.max(0, Math.ceil(left / 1000));
}
